import React from 'react';
import { useIntl } from 'react-intl';
import { InputField } from '@cim-ui/cim-shared';
import OnboardingEmails from './OnboardingEmails';
const OnboardingDetails = () => {
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(InputField, {
    name: "firstName",
    label: formatMessage({
      id: 'registration.firstName'
    }),
    className: "col-md-6 margin-responsive-t",
    autoComplete: "given-name",
    "aria-required": true,
    isRequired: true
  }), /*#__PURE__*/React.createElement(InputField, {
    name: "lastName",
    label: formatMessage({
      id: 'registration.lastName'
    }),
    className: "col-md-6 margin-responsive-t",
    autoComplete: "family-name",
    "aria-required": true,
    isRequired: true
  }), /*#__PURE__*/React.createElement(InputField, {
    name: "companyName",
    label: formatMessage({
      id: 'registration.companyName'
    }),
    className: "col-md-6 margin-responsive-t",
    autoComplete: "organization",
    "aria-required": true,
    isRequired: true
  }), /*#__PURE__*/React.createElement(InputField, {
    name: "taxIdNumber",
    label: formatMessage({
      id: 'registration.taxIdNumber'
    }),
    className: "col-md-6 margin-responsive-t"
  }), /*#__PURE__*/React.createElement(OnboardingEmails, null));
};
export default OnboardingDetails;